import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import calendar from "../../assets/images/icons/calendar.svg"
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"
import { useLazyGetReportsDataQuery } from "store/api/reports/reports"
import moment from "moment"
import FullPageLoader from "components/fullPageLoader"
import { formatIndianCurrency, formatIndianNumber } from "helpers/utils"

const GenerateFinancialReports = () => {
  const [trigger, { isLoading }] = useLazyGetReportsDataQuery()
  const [date, setDate] = useState([
    moment().subtract(3, "months").toDate(),
    moment().toDate(),
  ])
  const [data, setData] = useState(null)

  const getReportsData = async () => {
    try {
      const { data } = await trigger({ date }).unwrap()
      setData(data)
    } catch (error) {}
  }

  useEffect(() => {
    getReportsData()
  }, [date])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Generate Financial Reports"}
            breadcrumbItem={"Financial Reports"}
          />
          <Card>
            <CardBody>
              {isLoading ? (
                <FullPageLoader />
              ) : (
                <>
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-4 gap-md-2 mb-4">
                    <div>
                      <div className="input-wrapper">
                        <FlatPickr
                          id="fund_requirement_date"
                          name="fund_requirement_date"
                          className="form-control"
                          style={{
                            fontSize: "14px",
                            minWidth: "260px",
                          }}
                          placeholder="Jan 10, 2025 – Jan 16, 2025"
                          options={{
                            mode: "range",
                            dateFormat: "d M, Y",
                            closeOnSelect: false,
                          }}
                          value={date}
                          onChange={(date) => {
                            if (date.length === 2) {
                              setDate(date)
                            }
                          }}
                        />
                        <img src={calendar} alt="" />
                      </div>
                    </div>
                    {/* <div className="download-link">
                      <p>PDF</p>
                      <p>CSV</p>
                    </div> */}
                  </div>
                  <div className="card-reports-wrapper">
                    <Row>
                      <Col xl={4}>
                        <div className="card-box">
                          <h3>Total Investment Amount</h3>
                          <h4>
                            ₹{" "}
                            {formatIndianCurrency(data?.total?.totalInvestment)}
                          </h4>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="card-box">
                          <h3>Total Interest Disbursed</h3>
                          <h4>
                            ₹ {formatIndianCurrency(data?.total?.totalInterest)}
                          </h4>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="card-box">
                          <h3>Total No. of Investment</h3>
                          <h4>
                            {formatIndianNumber(data?.total?.noOfInvestment)}
                          </h4>
                        </div>
                      </Col>
                    </Row>
                    {/* <Col xl={12}>
                      <div className="label-header">
                        <i className="icon-icd"></i> <p>ICDs</p>
                      </div>
                    </Col>
                    <Row>
                      <Col xl={4}>
                        <div className="icd-card-wrapper">
                          <div className="icon-wrapper">
                            <i className="icon-brifcase"></i>
                          </div>
                          <div>
                            <h3>Total Investment Amount</h3>
                            <h4>
                              ₹{" "}
                              {formatIndianCurrency(
                                data?.icdData?.totalInvestment
                              )}
                            </h4>
                          </div>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="icd-card-wrapper">
                          <div className="icon-wrapper">
                            <i className="icon-wallet"></i>
                          </div>
                          <div>
                            <h3>Total Interest Disbursed</h3>
                            <h4>
                              ₹{" "}
                              {formatIndianCurrency(
                                data?.icdData?.totalInterest
                              )}
                            </h4>
                          </div>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="icd-card-wrapper">
                          <div className="icon-wrapper">
                            <i className="icon-total-investors"></i>
                          </div>
                          <div>
                            <h3>Total No. of Investment</h3>
                            <h4>
                              {formatIndianNumber(
                                data?.icdData?.noOfInvestment
                              )}
                            </h4>
                          </div>
                        </div>
                      </Col>
                    </Row> */}
                    {/* <Col xl={12}>
                      <div className="label-header">
                        <i className="icon-ul-bonds"></i> <p>Unlisted Bonds</p>
                      </div>
                    </Col>
                    <Row>
                      <Col xl={4}>
                        <div className="icd-card-wrapper unlisted-bonds">
                          <div className="icon-wrapper">
                            <i className="icon-brifcase"></i>
                          </div>
                          <div>
                            <h3>Total Investment Amount</h3>
                            <h4>
                              {formatIndianCurrency(
                                data?.bondData?.totalInvestment
                              )}
                            </h4>
                          </div>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="icd-card-wrapper unlisted-bonds">
                          <div className="icon-wrapper">
                            <i className="icon-wallet"></i>
                          </div>
                          <div>
                            <h3>Total Interest Disbursed</h3>
                            <h4>
                              {formatIndianCurrency(
                                data?.bondData?.totalInterest
                              )}
                            </h4>
                          </div>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="icd-card-wrapper unlisted-bonds">
                          <div className="icon-wrapper">
                            <i className="icon-total-investors"></i>
                          </div>
                          <div>
                            <h3>Total No. of Investment</h3>
                            <h4>
                              {formatIndianCurrency(
                                data?.bondData?.noOfInvestment
                              )}
                            </h4>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Col xl={12}>
                      <div className="label-header">
                        <i className="icon-reit"></i> <p>REITs</p>
                      </div>
                    </Col>
                    <Row>
                      <Col xl={4}>
                        <div className="icd-card-wrapper reit-wrapper">
                          <div className="icon-wrapper">
                            <i className="icon-brifcase"></i>
                          </div>
                          <div>
                            <h3>Total Investment Amount</h3>
                            <h4>150.4k</h4>
                          </div>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="icd-card-wrapper reit-wrapper">
                          <div className="icon-wrapper">
                            <i className="icon-wallet"></i>
                          </div>
                          <div>
                            <h3>Total Interest Disbursed</h3>
                            <h4>48k</h4>
                          </div>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="icd-card-wrapper reit-wrapper">
                          <div className="icon-wrapper">
                            <i className="icon-total-investors"></i>
                          </div>
                          <div>
                            <h3>Total No. of Investment</h3>
                            <h4>2.1k</h4>
                          </div>
                        </div>
                      </Col>
                    </Row> */}
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default GenerateFinancialReports
